import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FRONT_RESOURCE, FRONT_RESPONSE, FRONTSETTINGS } from '../interfaces/front-settings.interface';
import { HttpClient } from '@angular/common/http';
import { apiConfiguration } from '../app.config';
import { UtilService } from './util.service';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class FrontSettingsService {

  private frontSettings = new BehaviorSubject<FRONTSETTINGS>({});
  frontSettings$ = this.frontSettings.asObservable();

  constructor(private http: HttpClient,
    private _utilService: UtilService
  ) { }

  init() {
    //Api configuration
    this._utilService.setLoadingStatusApp(true);

    this.getFrontSettings().subscribe(resources => {
      this.assignResources(resources);
    });

    /* setTimeout(() => {
      this._utilService.setLoadingStatusApp(false);
    }, 2000); */
  }

  getFrontSettings(): Observable<FRONT_RESPONSE> {
    const timestamp = new Date().getTime();
    const url = `${environment.url}/v1/parameterized-texts?nocache=${timestamp}`;
    return this.http.get<FRONT_RESPONSE>(url);
  }

  private assignResources(resources: FRONT_RESPONSE): void {
    const settings: FRONTSETTINGS = {} as FRONTSETTINGS;

    resources.content.forEach(resource => {

      const resourceKey = resource.id as keyof FRONTSETTINGS;

      if (resource.id && resource.parent == null) {
        const resourceList = resources.content.filter(x => x.parent == resource.id);
        if (resourceList != null && resourceList.length > 0) {
          (settings[resourceKey] as FRONT_RESOURCE[]) = resourceList;
        } else {
          (settings[resourceKey] as FRONT_RESOURCE) = resource;
        }
      }
    });

    this.frontSettings.next(settings);
    setTimeout(() => {
      this._utilService.setLoadingStatusApp(false);
    }, 1000);

  }

}
